export enum HallsActionTypes {
    GET_HALLS_LIST = "[App Action][Halls] GET HALLS LIST",
    GET_HALLS_LIST_SUCCESS = "[App Action][Halls] GET HALLS LIST SUCCESS",
    GET_HALLS_LIST_FAIL = "[App Action][Halls] GET HALLS LIST FAIL",

    GET_HALL = "[App Action][Halls] GET HALL",
    GET_HALL_SUCCESS = "[App Action][Halls] GET HALL SUCCESS",
    GET_HALL_FAIL = "[App Action][Halls] GET HALL FAIL",

    GET_SERVERS = "[App Action][Halls] GET SERVERS",
    GET_SERVERS_SUCCESS = "[App Action][Halls] GET SERVERS SUCCESS",
    GET_SERVERS_FAIL = "[App Action][Halls] GET SERVERS FAIL",

    CLEAN_SERVER = "[App Action][Halls] CLEAN SERVER",

    GET_SERVER = "[App Action][Halls] GET SERVER",
    GET_SERVER_SUCCESS = "[App Action][Halls] GET SERVER SUCCESS",
    GET_SERVER_FAIL = "[App Action][Halls] GET SERVER FAIL",

    INSPECT_SERVER = "[App Action][Halls] INSPECT SERVER",

    GET_CONFIGURATIONS_LIST = "[App Action][Halls] GET CONFIGURATIONS LIST",
    GET_CONFIGURATIONS_LIST_SUCCESS = "[App Action][Halls] GET CONFIGURATIONS LIST SUCCESS",
    GET_CONFIGURATIONS_LIST_FAIL = "[App Action][Halls] GET CONFIGURATIONS LIST FAIL",

    GET_SUBSIDIARIES = "[App Action][Halls] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Halls] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Halls] GET SUBSIDIARIES FAIL",

    GET_TIMEZONES = "[App Action][Halls] GET TIMEZONES",
    GET_TIMEZONES_SUCCESS = "[App Action][Halls] GET TIMEZONES SUCCESS",
    GET_TIMEZONES_FAIL = "[App Action][Halls] GET TIMEZONES FAIL",

    CHANGE_HALL_LIST_FILTER = "[App Action][Halls] CHANGE HALL LIST FILTER",
    CLEAR_HALL_LIST_FILTER = "[App Action][Halls] CLEAR HALL LIST FILTER",
    CLEAR_HALL_LIST_FILTERS = "[App Action][Halls] CLEAR HALL LIST FILTERS",

    UPDATE_CREATING_HALL = "[App Action][Halls] UPDATE CREATING HALL",
    UPDATE_MAP_COORDINATES = "[App Action][Halls] UPDATE MAP COORDINATES",

    CREATE_HALL = "[App Action][Halls] CREATE HALL",
    CREATE_HALL_SUCCESS = "[App Action][Halls] CREATE HALL SUCCESS",
    CREATE_HALL_FAIL = "[App Action][Halls] CREATE HALL FAIL",
    CREATE_HALL_RESET = "[App Action][Halls] CREATE HALL RESET",

    UPDATE_HALL = "[App Action][Halls] UPDATE HALL",
    UPDATE_HALL_SUCCESS = "[App Action][Halls] UPDATE HALL SUCCESS",
    UPDATE_HALL_FAIL = "[App Action][Halls] UPDATE HALL FAIL",
    UPDATE_HALL_RESET = "[App Action][Halls] UPDATE HALL RESET",

    UPDATE_SUGGESTIONS = "[App Action][Halls] UPDATE SUGGESTIONS",
    UPDATE_SUGGESTIONS_SUCCESS = "[App Action][Halls] UPDATE SUGGESTIONS SUCCESS",
    UPDATE_SUGGESTIONS_FAIL = "[App Action][Halls] UPDATE SUGGESTIONS FAIL",

    PICK_SUGGESTION = "[App Action][Halls] PICK SUGGESTION",

    MAP_CLICK = "[App Action][Halls] MAP CLICK",
    MAP_CLICK_SUCCESS = "[App Action][Halls] MAP CLICK SUCCESS",
    MAP_CLICK_FAIL = "[App Action][Halls] MAP CLICK FAIL",

    CREATE_SERVER = "[App Action][Halls] CREATE SERVER",
    CREATE_SERVER_SUCCESS = "[App Action][Halls] CREATE SERVER SUCCESS",
    CREATE_SERVER_FAIL = "[App Action][Halls] CREATE SERVER FAIL",
    CLONE_SERVER = "[App Action][Halls] CLONE SERVER",
    CLONE_SERVER_SUCCESS = "[App Action][Halls] CLONE SERVER SUCCESS",
    CLONE_SERVER_FAIL = "[App Action][Halls] CLONE SERVER FAIL",

    //GET_CASH_SYSTEMS = "[App Action][Halls] GET CASH SYSTEMS",
    //GET_CASH_SYSTEMS_SUCCESS = "[App Action][Halls] GET CASH SYSTEMS SUCCESS",
    //GET_CASH_SYSTEMS_FAIL = "[App Action][Halls] GET CASH SYSTEMS FAIL",

    GET_CORE_VERSIONS = "[App Action][Halls] GET CORE VERSIONS",
    GET_CORE_VERSIONS_SUCCESS = "[App Action][Halls] GET CORE VERSIONS SUCCESS",
    GET_CORE_VERSIONS_FAIL = "[App Action][Halls] GET CORE VERSIONS FAIL",

    CREATION_MODE_CHANGE = "[App Action][Halls] CREATION MODE CHANGE",

    TOGGLE_HALL_ACTIVE = "[App Action][Halls] TOGGLE HALL ACTIVE",
    TOGGLE_HALL_ACTIVE_SUCCESS = "[App Action][Halls] TOGGLE HALL ACTIVE SUCCESS",
    TOGGLE_HALL_ACTIVE_FAIL = "[App Action][Halls] TOGGLE HALL ACTIVE FAIL",

    DELETE_HALL = "[App Action][Halls] DELETE HALL",

    TOGGLE_SERVER_ACTIVE = "[App Action][Halls] TOGGLE SERVER ACTIVE",
    TOGGLE_SERVER_ACTIVE_SUCCESS = "[App Action][Halls] TOGGLE SERVER ACTIVE SUCCESS",
    TOGGLE_SERVER_ACTIVE_FAIL = "[App Action][Halls] TOGGLE SERVER ACTIVE FAIL",

    TOGGLE_SERVER_DEBUG_MODE = "[App Action][Halls] TOGGLE SERVER DEBUG MODE",
    TOGGLE_SERVER_DEBUG_MODE_SUCCESS = "[App Action][Halls] TOGGLE SERVER DEBUG MODE SUCCESS",
    TOGGLE_SERVER_DEBUG_MODE_FAIL = "[App Action][Halls] TOGGLE SERVER DEBUG MODE FAIL",

    TOGGLE_SERVER_PERPETUAL_LICENSE = "[App Action][Halls] TOGGLE SERVER PERPETUAL LICENSE",
    TOGGLE_SERVER_PERPETUAL_LICENSE_SUCCESS = "[App Action][Halls] TOGGLE SERVER PERPETUAL LICENSE SUCCESS",
    TOGGLE_SERVER_PERPETUAL_LICENSE_FAIL = "[App Action][Halls] TOGGLE SERVER PERPETUAL LICENSE FAIL",

    GET_SERVERS_INFO = "[App Action][Halls] GET SERVERS INFO",
    GET_SERVERS_INFO_SUCCESS = "[App Action][Halls] GET SERVERS INFO SUCCESS",
    GET_SERVERS_INFO_FAIL = "[App Action][Halls] GET SERVERS INFO FAIL",

    UPDATE_SERVER = "[App Action][Halls] UPDATE SERVER",
    UPDATE_SERVER_SUCCESS = "[App Action][Halls] UPDATE SERVER SUCCESS",
    UPDATE_SERVER_FAIL = "[App Action][Halls] UPDATE SERVER FAIL",

    GET_COMPARE_CONFIGURATIONS = "[App Action][Halls] GET COMPARE CONFIGURATIONS",
    GET_COMPARE_CONFIGURATIONS_SUCCESS = "[App Action][Halls] GET COMPARE CONFIGURATIONS SUCCESS",
    GET_COMPARE_CONFIGURATIONS_FAIL = "[App Action][Halls] GET COMPARE CONFIGURATIONS FAIL",
    GET_COMPARE_CONFIGURATIONS_CLEAR = "[App Action][Halls] GET COMPARE CONFIGURATIONS CLEAR",

    UPLOAD_CONFIGURATION = "[App Action][Halls] UPLOAD CONFIGURATION",
    UPLOAD_CONFIGURATION_SUCCESS = "[App Action][Halls] UPLOAD CONFIGURATION SUCCESS",
    UPLOAD_CONFIGURATION_FAIL = "[App Action][Halls] UPLOAD CONFIGURATION FAIL",

    UPLOAD_CONFIGURATION_REMOTELY = "[App Action][Halls] UPLOAD CONFIGURATION REMOTELY",
    UPLOAD_CONFIGURATION_REMOTELY_SUCCESS = "[App Action][Halls] UPLOAD CONFIGURATION REMOTELY SUCCESS",
    UPLOAD_CONFIGURATION_REMOTELY_FAIL = "[App Action][Halls] UPLOAD CONFIGURATION REMOTELY FAIL",

    GET_SERVER_LICENSE = "[App Action][Halls] GET SERVER LICENSE",
    GET_SERVER_LICENSE_SUCCESS = "[App Action][Halls] GET SERVER LICENSE SUCCESS",
    GET_SERVER_LICENSE_FAIL = "[App Action][Halls] GET SERVER LICENSE FAIL",
    UPDATE_LICENSE_STATE = "[App Action][Halls] UPDATE LICENSE STATE",

    UPLOAD_LICENSE_SEED = "[App Action][Halls] UPLOAD LICENSE SEED",
    UPLOAD_LICENSE_SEED_SUCCESS = "[App Action][Halls] UPLOAD LICENSE SEED SUCCESS",
    UPLOAD_LICENSE_SEED_FAIL = "[App Action][Halls] UPLOAD LICENSE SEED FAIL",

    GET_SERVER_LICENSE_STATE = "[App Action][Halls] GET SERVER LICENSE STATE",
    GET_SERVER_LICENSE_STATE_SUCCESS = "[App Action][Halls] GET SERVER LICENSE STATE SUCCESS",
    GET_SERVER_LICENSE_STATE_FAIL = "[App Action][Halls] GET SERVER LICENSE STATE FAIL",

    CANCEL_LICENSE_PROCESS = "[App Action][Halls] CANCEL SERVER LICENSE PROCESS",
    CANCEL_LICENSE_PROCESS_SUCCESS = "[App Action][Halls] CANCEL SERVER LICENSE PROCESS SUCCESS",
    CANCEL_LICENSE_PROCESS_FAIL = "[App Action][Halls] CANCEL SERVER LICENSE PROCESS FAIL",

    REJECT_LICENSE_ID = "[App Action][Halls] REJECT SERVER LICENSE ID",
    REJECT_LICENSE_ID_SUCCESS = "[App Action][Halls] REJECT SERVER LICENSE ID SUCCESS",
    REJECT_LICENSE_ID_FAIL = "[App Action][Halls] REJECT SERVER LICENSE ID FAIL",

    CONFIRM_LICENSE_ID = "[App Action][Halls] CONFIRM SERVER LICENSE ID",
    CONFIRM_LICENSE_ID_SUCCESS = "[App Action][Halls] CONFIRM SERVER LICENSE ID SUCCESS",
    CONFIRM_LICENSE_ID_FAIL = "[App Action][Halls] CONFIRM SERVER LICENSE ID FAIL",

    UPDATE_LICENSE_DURATION = "[App Action][Halls] UPDATE LICENSE DURATION",
    UPDATE_LICENSE_DURATION_SUCCESS = "[App Action][Halls] UPDATE LICENSE DURATION SUCCESS",
    UPDATE_LICENSE_DURATION_FAIL = "[App Action][Halls] UPDATE LICENSE DURATION FAIL",
    CLEAR_LICENSE_DURATION = "[App Action][Halls] CLEAR LICENSE DURATION",

    GET_LICENSE_DOWNLOAD = "[App Action][Halls] GET LICENSE DOWNLOAD",
    GET_LICENSE_DOWNLOAD_SUCCESS = "[App Action][Halls] GET LICENSE DOWNLOAD SUCCESS",
    GET_LICENSE_DOWNLOAD_FAIL = "[App Action][Halls] GET LICENSE DOWNLOAD FAIL",

    SET_LICENSE_APPLIED = "[App Action][Halls] SET LICENSE APPLIED",
    SET_LICENSE_APPLIED_SUCCESS = "[App Action][Halls] GET LICENSE APPLIED SUCCESS",
    SET_LICENSE_APPLIED_FAIL = "[App Action][Halls] GET LICENSE APPLIED FAIL",

    RENEW_LICENSE = "[App Action][Halls] RENEW LICENSE",
    RENEW_LICENSE_SUCCESS = "[App Action][Hall] RENEW LICENSE SUCCESS",
    RENEW_LICENSE_FAIL = "[App Action][Hall] RENEW LICENSE FAIL",

    UPDATE_REMOTELY_LICENSE = "[App Action][Halls] UPDATE REMOTELY LICENSE",
    UPDATE_REMOTELY_LICENSE_SUCCESS = "[App Action][Hall] UPDATE REMOTELY LICENSE SUCCESS",
    UPDATE_REMOTELY_LICENSE_FAIL = "[App Action][Hall] UPDATE REMOTELY LICENSE FAIL",

    INVALIDATE_LICENSE = "[App Action][Halls] INVALIDATE LICENSE",
    INVALIDATE_LICENSE_SUCCESS = "[App Action][Hall] INVALIDATE LICENSE SUCCESS",
    INVALIDATE_LICENSE_FAIL = "[App Action][Hall] INVALIDATE LICENSE FAIL",

    GET_LICENSE_ACTIVITY = "[App Action][Halls] GET LICENSE ACTIVITY",
    GET_LICENSE_ACTIVITY_SUCCESS = "[App Action][Halls] GET LICENSE ACTIVITY SUCCESS",
    GET_LICENSE_ACTIVITY_FAIL = "[App Action][Halls] GET LICENSE ACTIVITY FAIL",
    RESET_ACTIVITIES = "[App Action][Halls] RESET ACTIVITIES",

    UPLOAD_SYSTEM_SPECIFICATION = "[App Action][Halls] UPLOAD SYSTEM SPECIFICATION",
    UPLOAD_SYSTEM_SPECIFICATION_SUCCESS = "[App Action][Halls] UPLOAD SYSTEM SPECIFICATION SUCCESS",
    UPLOAD_SYSTEM_SPECIFICATION_FAIL = "[App Action][Halls] UPLOAD SYSTEM SPECIFICATION FAIL",
    REMOVED_SPECIFICATION_SELECTION = "[App Action][Halls] REMOVED SPECIFICATION SELECTION",

    GET_SPECIFICATION_ACTIVITY = "[App Action][Halls] GET SPECIFICATION ACTIVITY",
    GET_SPECIFICATION_ACTIVITY_SUCCESS = "[App Action][Halls] GET SPECIFICATION ACTIVITY SUCCESS",
    GET_SPECIFICATION_ACTIVITY_FAIL = "[App Action][Halls] GET SPECIFICATION ACTIVITY FAIL",

    GET_DYNAMIC_HALL = "[App Action][Halls] GET DYNAMIC HALL",
    GET_DYNAMIC_HALL_SUCCESS = "[App Action][Halls] GET DYNAMIC HALL SUCCESS",
    GET_DYNAMIC_HALL_FAIL = "[App Action][Halls] GET DYNAMIC HALL FAIL",

    GET_DYNAMIC_HALL_INFO = "[App Action][Halls] GET DYNAMIC HALL INFO",
    GET_DYNAMIC_HALL_INFO_SUCCESS = "[App Action][Halls] GET DYNAMIC HALL INFO SUCCESS",
    GET_DYNAMIC_HALL_INFO_FAIL = "[App Action][Halls] GET DYNAMIC HALL INFO FAIL",
    CLEAR_DYNAMIC_HALL_INFO = "[App Action][Halls] CLEAR DYNAMIC HALL INFO",

    GET_PRODUCTION_INFO = "[App Action][Halls] GET PRODUCTION INFO",
    GET_PRODUCTION_INFO_SUCCESS = "[App Action][Halls] GET PRODUCTION INFO SUCCESS",
    GET_PRODUCTION_INFO_FAIL = "[App Action][Halls] GET PRODUCTION INFO FAIL",
}
